function DialogueLayout() {
  return <div></div>;
}

export default DialogueLayout;
